export default function MatchTable() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-xs">
          <thead>
            <tr className="bg-blue-600 text-white">
              <th className="border border-gray-300 px-2 py-2 text-center" colSpan={6}>
                Match Schedule & Football Analysis
              </th>
            </tr>
            <tr className="bg-blue-300">
              <th className="border border-gray-300 px-2 py-2 text-center" colSpan={6}>
                Monday, 26 January 2025
              </th>
            </tr>
            <tr className="bg-yellow-200">
              <th className="border border-gray-300 px-2 py-2 text-center">Time</th>
              <th className="border border-gray-300 px-2 py-2 text-center">Home Team</th>
              <th className="border border-gray-300 px-2 py-2 text-center">Away Team</th>
              <th className="border border-gray-300 px-2 py-2 text-center">Odds</th>
              <th className="border border-gray-300 px-2 py-2 text-center">Result</th>
              <th className="border border-gray-300 px-2 py-2 text-center">Analysis</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-yellow-100">
              <td className="border border-gray-300 px-2 py-2 text-center font-semibold" colSpan={6}>
                Secret Tips 4 Teams Daily - Send FS to 4899101 - 6 Baht per message - Receive 16:00-17:00 daily
              </td>
            </tr>
            <tr className="bg-yellow-100">
              <td className="border border-gray-300 px-2 py-2 text-center font-semibold" colSpan={6}>
                A-League Australia
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-2 py-2 text-center">13:30</td>
              <td className="border border-gray-300 px-2 py-2 text-center text-red-600 font-semibold">Melbourne Victory</td>
              <td className="border border-gray-300 px-2 py-2 text-center">Sydney FC</td>
              <td className="border border-gray-300 px-2 py-2 text-center">0.5 -5</td>
              <td className="border border-gray-300 px-2 py-2 text-center">-</td>
              <td className="border border-gray-300 px-2 py-2 text-center">Sydney FC should get points</td>
            </tr>
            <tr className="bg-yellow-100">
              <td className="border border-gray-300 px-2 py-2 text-center font-semibold" colSpan={6}>
                Premier League England
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-2 py-2 text-center">03:00</td>
              <td className="border border-gray-300 px-2 py-2 text-center text-red-600 font-semibold">Everton</td>
              <td className="border border-gray-300 px-2 py-2 text-center">Leeds United</td>
              <td className="border border-gray-300 px-2 py-2 text-center">+10</td>
              <td className="border border-gray-300 px-2 py-2 text-center">-</td>
              <td className="border border-gray-300 px-2 py-2 text-center">Everton to win</td>
            </tr>
            <tr className="bg-yellow-100">
              <td className="border border-gray-300 px-2 py-2 text-center font-semibold" colSpan={6}>
                Championship England
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-2 py-2 text-center">03:00</td>
              <td className="border border-gray-300 px-2 py-2 text-center">Norwich City</td>
              <td className="border border-gray-300 px-2 py-2 text-center text-red-600 font-semibold">Coventry</td>
              <td className="border border-gray-300 px-2 py-2 text-center">0/0.5 -10</td>
              <td className="border border-gray-300 px-2 py-2 text-center">-</td>
              <td className="border border-gray-300 px-2 py-2 text-center">Norwich City has tips</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div className="mt-4 p-3 bg-gray-100 rounded">
        <table className="w-full text-xs">
          <tbody>
            <tr>
              <td className="py-1 px-2 bg-red-600 w-24"></td>
              <td className="py-1 px-2 font-semibold">Full Win</td>
            </tr>
            <tr>
              <td className="py-1 px-2 bg-green-400 w-24"></td>
              <td className="py-1 px-2 font-semibold">Half Win</td>
            </tr>
            <tr>
              <td className="py-1 px-2 bg-yellow-300 w-24"></td>
              <td className="py-1 px-2 font-semibold">Half Loss</td>
            </tr>
            <tr>
              <td className="py-1 px-2 bg-pink-400 w-24"></td>
              <td className="py-1 px-2 font-semibold">Draw</td>
            </tr>
            <tr>
              <td className="py-1 px-2 bg-gray-400 w-24"></td>
              <td className="py-1 px-2 font-semibold">Postponed</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}